import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import OrderDriverAutocomplete from "../OrderDriverAutocomplete";
import {
  autocompleteFieldLegendSx,
  driverFieldColumnWidthSx,
} from "../OrderDriverAutocomplete/styles";
import { DriverSelectOption } from "../OrderDriverAutocomplete/types";
import * as Styled from "./styles";

interface DriverEditViewProps {
  loading: boolean;
  hasDriverInsights: boolean;
  options: DriverSelectOption[];
  value: DriverSelectOption | null;
  onChange: (option: DriverSelectOption | null) => void;
  onCancel: () => void;
  onApply: () => void;
}

function AutocompleteSkeleton(): JSX.Element {
  return (
    <Box sx={driverFieldColumnWidthSx}>
      <Skeleton
        variant="rounded"
        animation="wave"
        height={56}
        sx={{ borderRadius: "8px" }}
      />
    </Box>
  );
}

function DriverEditView({
  loading,
  hasDriverInsights,
  options,
  value,
  onChange,
  onCancel,
  onApply,
}: DriverEditViewProps): JSX.Element {
  const { t } = useTranslation();
  const inputHtmlId = useId();

  return (
    <Styled.DriverEditWrap>
      <Box sx={driverFieldColumnWidthSx}>
        {!loading ? (
          <Typography
            component="label"
            htmlFor={inputHtmlId}
            sx={autocompleteFieldLegendSx}
          >
            {t("replaceDelivery")}
          </Typography>
        ) : (
          <Skeleton
            variant="rounded"
            animation="wave"
            height={12}
            width="72%"
            sx={{ borderRadius: "4px", mb: "4px" }}
          />
        )}
      </Box>
      <Styled.DriverEditActionsRow>
        <Box sx={{ ...driverFieldColumnWidthSx }}>
          {loading ? (
            <AutocompleteSkeleton />
          ) : (
            <OrderDriverAutocomplete
              hideLegend
              inputHtmlId={inputHtmlId}
              hasDriverInsights={hasDriverInsights}
              options={options}
              value={value}
              onChange={onChange}
            />
          )}
        </Box>
        <Styled.ContainerButtonsDrive>
          <Styled.ButtonBackDrive type="button" onClick={onCancel}>
            <Typography variant="button" textAlign="start">
              {t("exit")}
            </Typography>
          </Styled.ButtonBackDrive>
          <Styled.ButtonApplyDrive
            type="button"
            disabled={loading || !value}
            onClick={onApply}
          >
            <Typography variant="button" textAlign="start">
              {t("toApply")}
            </Typography>
          </Styled.ButtonApplyDrive>
        </Styled.ContainerButtonsDrive>
      </Styled.DriverEditActionsRow>
    </Styled.DriverEditWrap>
  );
}

export default DriverEditView;
